import { FC } from "react";
import { AllieFabButtonProps } from "./FabButton.types";
import {  StyledFabButton } from "./FabButton.styles";

export const AllieFabButton: FC<AllieFabButtonProps> = (props) => <StyledFabButton {...props} />;
